// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","passengers":"passengers-20P_B"};